// extracted by mini-css-extract-plugin
export default {"root":"labelsContainer-module__root__IlNHn","rootMobile":"labelsContainer-module__rootMobile__KQDt+","labelIcon":"labelsContainer-module__labelIcon__F0LOe"};